/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
     <br>
  <div>
  <div class="formPosition">

      <v-card style="margin:auto;" width="1200" >
        <v-card-title style="background-color:#006699;color:white;"></v-card-title>
    <v-progress-linear
      v-if="progresso"
        indeterminate
        color="green"
        height="10"
      ></v-progress-linear>
       <v-card-title>
        <v-row >
           <v-col md="6"><span>Facturas de compras ao fornecedor </span></v-col>
            <v-col md="4">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Pesquisar pela referência do produto ou código de barra"
                single-line
                hide-details
              ></v-text-field>
           </v-col>
           <v-col md="2">
             <v-btn color="primary" @click="$router.push('Nova-fatura')" style="margin-top:15px;">Novo Factura <v-icon>add</v-icon></v-btn>
           </v-col>
         </v-row>
         </v-card-title>

           <!-- ======================== Lista dos Itens da Fatura ============================= -->

              <template>
                  <v-row justify="center">
                    <v-dialog v-model="dialog" persistent max-width="1090">
                      <v-card>
                        <v-card-title class="headline" style="background-color:#006699;color:white;">Detalhes da Fatura</v-card-title>
                        <v-card-text>
                          <span style="font-weight:bold;margin-left:-15px;">Dados Gerais:</span>
                          <v-row style="border:1px solid #cccccc">
                            <v-col md="12">
                               <span>Documento: </span><span style="font-weight:bold;">{{editedItem.documento}}</span>
                             </v-col>
                             <v-col md="12">
                               <span>Referência: </span><span style="font-weight:bold;">{{editedItem.referencia}}</span>
                             </v-col>
                             <v-col md="12">
                               <span>Valor: </span><span style="font-weight:bold;">{{utilitarios.IntegerToMoneyValue(editedItem.totalFatura)}}</span>
                             </v-col>
                             <v-col md="12">
                               <span>Data de Cadastro: </span><span style="font-weight:bold;">{{editedItem.data_created}}</span>
                             </v-col>
                             <v-col md="12">
                               <span>Cadastra por: </span><span style="font-weight:bold;">{{editedItem.autor}}</span>
                             </v-col>
                          </v-row>
                          <v-data-table :headers="headersDetalhes" :items="produtosFatura">totalFatura
                          <template v-slot:item.precoUnitario="{ item }">
                              <span>{{utilitarios.IntegerToMoneyValue(item.precoUnitario)}}</span>
                          </template>
                          <template v-slot:item.custoCompra="{ item }">
                              <span>{{utilitarios.IntegerToMoneyValue(item.custoCompra)}}</span>
                          </template>
                        </v-data-table>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" text @click="dialog = false">Fechar</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </template>

      <!-- ======================= FIM dos Itens da Fatura ================================-->
      
        <template>
          <v-data-table :headers="headers" :items="produtos">totalFatura
            <template v-slot:item.totalFatura="{ item }">
                <span>{{utilitarios.IntegerToMoneyValue(item.totalFatura)}}</span>
            </template>
            <template v-slot:item.custoTransporte="{ item }">
                <span>{{utilitarios.IntegerToMoneyValue(item.custoTransporte)}}</span>
            </template>
             <template v-slot:item.status="{ item }">
                <span style="color:red;" v-if="item.status === 1">Usada</span>
                <span style="color:green;" v-if="item.status === 0">Disponível</span>
            </template>
            <template v-slot:item.action="{ item }">
                <v-btn @click="ListarItens(item)" color="#006699" style="color:white" small fab><v-icon>horizontal_split</v-icon></v-btn>
            </template>
          </v-data-table>
        </template>
      </v-card>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    alert: false,
    iconAlert: '',
    alertType: '',
    colorAlert: '',
    msgAlert: '',
    utilitarios: utilitarios,
    allowSpaces: false,
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    tab: null,
    datebi: null,
    date: null,
    novo: false,
    dialog: false,
    progresso: false,
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    menubi: false,
    ano_actual: ls.get('anolectivo'),
    habilitaBi: false,
    startDate: null,
    cursos: [],
    isLoading: false,
    turmasAll: [],
    produtosFatura: [],
    servico: '',
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    produtos: [],
    cor: '',
    municipiosFiltered: [],
    provincias: [],

    searchInDb: '',
    estudantes: [],
    recibos: [],
    servicos: [],
    dialogGrupo: false,
    dialogTaxa: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Identificador da Factura',
        align: 'start',
        sortable: false,
        value: 'referencia'
      },
      { text: 'Descrição', value: 'descricao' },
      { text: 'Data de compra', value: 'dataCompra' },
      { text: 'Custo de Compra', value: 'totalFatura' },
      { text: 'Custo de Transporte', value: 'custoTransporte' },
      { text: 'IVA', value: 'iva' },
      { text: 'Fornecedor', value: 'nome' },
      { text: 'Estado', value: 'status' },
      { text: 'Ação', value: 'action' }
    ],
    headersDetalhes: [
      {
        text: 'Produtos',
        align: 'start',
        sortable: false,
        value: 'nomeProduto'
      },
      { text: 'Operação', value: 'operacaoStock' },
      { text: 'Quantidade', value: 'qtd' },
      { text: 'Preço Unitário', value: 'precoUnitario' },
      { text: 'Custo total', value: 'custoCompra' },
      { text: 'Data de entrada', value: 'data_' }
    ],
    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editedItem: {
      custoTransporte: '',
      dataCompra: '',
      descricao: '',
      iva: '',
      motivoIsencao: '',
      nome: '',
      pkFaturaCompra: '',
      referencia: '',
      totalFatura: '',
      autor: '',
      data_created: '',
      documento: ''
    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      bi: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: '',
      // eslint-disable-next-line no-dupe-keys
      bi: '',
      ResidenteEm: '',
      instituicao: '',
      instituicaodescricao: '',
      curso: null,
      turma: null
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initialize()
  },

  methods: {
    async initialize () {
      try {
        this.progresso = true
        this.produtos = await axios
          .get('/Factura-compra-findAll')
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async initializeFaturaItens (item) {
      try {
        this.progresso = true
        this.produtosFatura = await axios
          .get('/ItemsFatura/' + item.pkFaturaCompra)
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    // combo qua depende de outra combo
    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL
    outroDoc () {
      if (this.descricao === 'Outro Doc.') {
        this.editedItem.bi = ''
        this.descricao = 'Nº do Bi'
        this.mascara = '#########-AA-###'
        this.ruleBI =
        [
          value => value.length === 16 || 'Minimo de caracteres exigido( 16 )'
        ]
      } else {
        this.editedItem.bi = ''
        this.descricao = 'Outro Doc.'
        this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
        this.ruleBI =
        [
          // eslint-disable-next-line no-mixed-operators
          value => value.length >= 16 && value.length <= 30 || 'Minimo de caracteres exigido( 16 )'
        ]
      }
    },

    loadTurmaComb (curso) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },

    chamaDialogo () {
      this.dialog = true
    },

    loadMunicipioComb (provincia) {
      this.$nextTick(() => { this.municSelectedForComb = undefined })
      // eslint-disable-next-line no-return-assign
      return this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia)
    },

    async ListarItens (item) {
      this.editedItem = Object.assign(this.editedItem, item)
      this.initializeFaturaItens(item).then(() => {
        this.dialog = true
      })
    },

    async initializeMunicipiosAll () {
      try {
        this.isLoading = true
        this.municipiosAll = await axios
          .get('/municipioFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async initializeProvincias () {
      try {
        this.isLoading = true
        this.provincias = await axios
          .get('/provinciaFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
        console.log(this.$store.state.actividades)
      } catch (error) {

      }
    },

    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
        console.log(this.cursos)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeturmasAll () {
    //  turmaFindWithEstudanteCount

      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll/' + this.idclasse)
          .then(res => res.data)
        this.isLoading = false
        console.log(this.turmasFiltered)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    editItem (item) {
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      // let v=  Object.assign({},  this.municipios[5]);
      try {
        // prara trazer valores default na combo
        // procura na collecao ja carregada
        this.municSelectedForComb = this.municipiosAll.filter(mun => mun.idMunicipio === item.idMunicipio)
        // seta o valor encontrado
        this.municSelectedForComb = this.municSelectedForComb[0]

        this.proviSelectedForComb = this.provincias.filter(
          prov => prov.idProvincia === this.municSelectedForComb.idProvincia
        )

        this.proviSelectedForComb = this.proviSelectedForComb[0]
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }

      this.dialog = true
    },

    deleteItem (item) {
      const index = this.estudantes.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.delete(item.pkPessoa)
      // this.estudantes.splice(index, 1)
    },
    close () {
      this.dialog = false
      this.$refs.form.reset()
    },
    saveDate (date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    saveDatebi (datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi
      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(date).toISOString().substr(0, 10)
    },
    async save () {
      if (this.$refs.form.validate()) {
        this.progresso = true
        let params =
          {
            pk_outros_servicos: 0,
            servico: this.servico
          }

        let params_tabela =
          {
            servico: params.servico,
            autor: ls.get('nomeUsuario'),
            data_: new Date()
          }

        try {
          let corMensagem = 'msgError'
          let msg = await axios
            .post('/servicosInsertOrUpdate', params)
            .then(res => res.data)

          if (msg.length) {
            corMensagem = 'msgError'
            this.text = 'Ocorreu um erro ao tentar efectuar a operação'
          } else {
            corMensagem = 'msgSuccess'
            this.text = 'Inserção efectuada com sucesso'
            this.servicos.unshift(params_tabela)
          }

          this.dialog = false
          this.progresso = false
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': corMensagem, 'timeout': 8000 })
        } catch (error) {
          console.log('eroooo: ' + error)
          this.text = error.message
        }
      }
    },

    EditarProduto (item) {
      console.log(item)
      this.dialog = true
    },

    Limpar () {
      this.editedItem.nome = ''
      this.editedItem.bi = ''
      this.editedItem.datanascimento = ''
      this.editedItem.nomedopai = ''
      this.editedItem.nomedamae = ''
      this.editedItem.dataemissaobi = ''
      this.editedItem.telefone = ''
    },

    async delete (idv) {
      try {
        var msg = await axios
          .get('/estudanteDeleteById/' + idv)
          .then(res => res.data)
        this.text = 'Deleted ' + msg.message

        this.initialize()

        this.close()
      } catch (error) {
        console.log('eroooo: ' + error)
        this.text = error.message
      } finally {

      }
    }
  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}

</style>
